module.exports = __webpack_public_path__ + "img/VE.7897bf62.svg";